/*eslint-disable*/
import OpenDocument from "helpers/openDocument";
import React from "react";


export default function Navbar({systemSettings}) {
  const [navbarOpen, setNavbarOpen] = React.useState(false);

  // Check if the current page is the login page or the landing page
  const isLoginPage = window.location.pathname === "/auth/login";
  const isLandingPage = window.location.pathname === "/";

  return (
    <>
      <nav className="top-0 absolute z-50 w-full flex items-center justify-between px-2 py-4 navbar-expand-lg">
        <div className="container px-4 mx-auto flex items-center justify-between">
          {/* Logo Section */}
          <div className="flex items-center justify-start">
            {/* <img
        src={ifLogoWhite}
        alt="IF Logo"
        className="h-16 w-auto"
      /> */}

            <OpenDocument
              mimeType={"image"}
              document={systemSettings?.logoImage}
              downloadable={false}
              type={"logo"}
              imgClassName="h-16 w-auto"
            />
          </div>

          <div
            className={
              "lg:flex flex-grow items-center bg-white lg:bg-opacity-0 lg:shadow-none" +
              (navbarOpen ? " block rounded shadow-lg" : " hidden")
            }
            id="example-navbar-warning"
          >
            <ul className="flex flex-col lg:flex-row list-none mr-auto"></ul>
            <ul className="flex flex-col lg:flex-row gap-6 list-none lg:ml-auto">
              {/* Conditionally rendered links */}
              {!isLandingPage && (
                <li className="flex items-center mr-3">
                  <a
                    href="https://qtglobal.rw/about"
                    className="text-white hover:underline"
                  >
                    About Us
                  </a>
                </li>
              )}
              <li className="flex items-center mr-3">
                <a
                  href="https://qtglobal.rw/contact"
                  className="text-white hover:underline"
                >
                  Support
                </a>
              </li>
              {isLandingPage && (
                <li className="flex items-center ">
                  <button
                    onClick={() => (window.location.href = "/auth/login")}
                    className=" text-white border border-white px-4 py-2 rounded shadow hover:shadow-md outline-none focus:outline-none lg:mr-1 lg:mb-0 ml-3 mb-3 ease-linear transition-all duration-150"
                    type="button"
                  >
                    Login
                  </button>
                </li>
              )}
            </ul>
          </div>
        </div>
      </nav>
    </>
  );
}
